import { FormInstance } from 'antd';
import type { FormValues } from './types';

export const validatePaymentDeadLineAndGenerateDate = ({
  getFieldValue,
}: {
  getFieldValue: FormInstance<FormValues>['getFieldValue'];
}) => ({
  validator() {
    const autoGenerateBillDate = getFieldValue('autoGenerateBillDate') || null;
    const paymentDeadline = getFieldValue('paymentDeadline') || null;
    if (autoGenerateBillDate && paymentDeadline.date) {
      if (paymentDeadline.type === 'current') {
        const period = autoGenerateBillDate - paymentDeadline.date;
        if ((period >= 1 && period <= 5) || (period >= -27 && period <= -23)) {
          return Promise.reject(
            new Error('每月以28天計算，繳費截止日後五日內不可為自動產生帳單日')
          );
        } else {
          return Promise.resolve();
        }
      }
      return Promise.resolve();
    } else {
      return Promise.resolve();
    }
  },
});

export const getDeadlineSetting = (
  generateDate: number,
  deadline: number
): {
  labels: [string, string];
  disabled: boolean;
} => {
  if (generateDate === deadline) {
    return {
      labels: ['同個月', '下個月'],
      disabled: true,
    };
  } else if (generateDate > deadline) {
    return {
      labels: ['下個月', '下下個月'],
      disabled: false,
    };
  } else {
    return {
      labels: ['同個月', '下個月'],
      disabled: false,
    };
  }
};
